module.exports = __webpack_public_path__ + "static/media/lukas-prudil-cv.dde4a436.doc";